import { render } from "./EditableJsonView.vue?vue&type=template&id=f35ee180&scoped=true"
import script from "./EditableJsonView.vue?vue&type=script&lang=js"
export * from "./EditableJsonView.vue?vue&type=script&lang=js"

import "./EditableJsonView.vue?vue&type=style&index=0&id=f35ee180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35ee180"]])

export default __exports__